// بناء صفوف سجل الطلبات (إجازة/استئناف/سلفة/استقالة/زمنية) مع تسميات مترجمة + الكائن الخام للـPDF.
export const buildRows = ({ hr, resumes, off, t }) => {
  const S = (s) => t(`myRequests.status.${s}`, { defaultValue: s });
  const d10 = (v) => (v || "").slice(0, 10);
  const rows = [];
  (hr.leaves || []).forEach((l) => rows.push({
    id: l.id, kind: "leave", who: l.user_name, ref: l.ref_no, status: l.status, note: l.decision_note,
    leaveType: l.leave_type, raw: l,
    title: `${t(`leaves.types.${l.leave_type}`)} · ${l.start_date} → ${l.end_date}`,
    kindLabel: t("myRequests.leave"), statusLabel: S(l.status),
    branch_id: l.branch_id, user_id: l.user_id, date: d10(l.created_at),
  }));
  (resumes || []).forEach((l) => rows.push({
    id: l.id, kind: "resume", who: l.user_name, ref: l.ref_no, status: "cancel_requested", note: l.decision_note,
    leaveType: l.leave_type, raw: l,
    title: `${l.start_date} → ${l.end_date}`, kindLabel: t("myRequests.resumeKind"), statusLabel: S("cancel_requested"),
    branch_id: l.branch_id, user_id: l.user_id, date: d10(l.created_at),
  }));
  (hr.advances || []).forEach((a) => rows.push({
    id: a.id, kind: "advance", who: a.user_name, ref: a.ref_no, status: a.status, note: a.decision_note, raw: a,
    title: `${a.amount} ${a.currency}`, kindLabel: t("myRequests.advance"), statusLabel: S(a.status),
    branch_id: a.branch_id, user_id: a.user_id, date: d10(a.created_at),
  }));
  (hr.resignations || []).forEach((x) => rows.push({
    id: x.id, kind: "resignation", who: x.user_name, ref: x.ref_no, status: x.status, note: x.decision_note, raw: x,
    title: x.last_working_day, kindLabel: t("myRequests.resignation"), statusLabel: S(x.status),
    branch_id: x.branch_id, user_id: x.user_id, date: d10(x.created_at),
  }));
  (Array.isArray(off) ? off : []).forEach((o) => rows.push({
    id: o.id, kind: "timeOff", who: o.user_name, ref: o.ref_no, status: o.status, note: o.decision_note,
    leaveType: "time_off", raw: o,
    title: `${t(`timeOff.type.${o.time_off_type}`)} · ${o.request_date}`,
    kindLabel: t("myRequests.timeOff"), statusLabel: S(o.status),
    branch_id: o.branch_id, user_id: o.user_id, date: d10(o.created_at),
  }));
  return rows;
};
